import React from "react";
import { createStyles, makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Button, Icon } from "@mui/material";

const useStyles = makeStyles((theme) =>
  createStyles({
    appBar: {
      position: "relative",
      backgroundColor: "#006fca",
    },
    toolbar: {
      minHeight: 40,
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
  })
);

export default function HeaderDialog(props) {
  const classes = useStyles();
  const { renderCustom, renderButton, title, onClose } = props;
  return (
    <AppBar style={{ position: "relative" }}>
      <Toolbar className={classes.toolbar} variant="dense">
        {renderCustom}
        <Typography variant="h6" className={classes.title}>
          {title}
        </Typography>
        {renderButton}
        <Button
          onClick={onClose}
          size="small"
          variant="contained"
          startIcon={<Icon style={{ color: "red" }}>cancel</Icon>}
        >
          Thoát
        </Button>
      </Toolbar>
    </AppBar>
  );
}
